/** TTL compartido para caches de sesión post-bootstrap (entitlements, flags, branches, bootstrap). */
export const SESSION_CACHE_MS = 15 * 60 * 1000;

/** Entitlements: cambian raro fuera de billing/onboarding. */
export const ENTITLEMENTS_CACHE_MS = 60 * 60 * 1000;

/** Feature flags: fail-open; cambian rarísimo. */
export const GLOBAL_FEATURE_FLAGS_CACHE_MS = 24 * 60 * 60 * 1000;

/** Cache del badge de soporte (OnFocus / AppState active). */
export const SUPPORT_UNREAD_CACHE_MS = 60 * 60 * 1000;

/** Poll de permissions_updated_at en dispositivo empleado (AppState + interval). */
export const EMPLOYEE_PERMISSIONS_FRESHNESS_POLL_MS = 5 * 60 * 1000;

/** Employees list (REST) — sesión. */
export const EMPLOYEES_CACHE_MS = 60 * 60 * 1000;

/** Web customer REST fallback cuando no hay snapshot SQLite. */
export const CUSTOMER_WEB_REST_CACHE_MS = 5 * 60 * 1000;
